import React, { useEffect, useRef } from 'react'

import { composeRefs } from '@/shared/lib/composition'
import { cn } from '@/shared/lib/utils'

export type CheckboxProps = {
	indeterminate?: boolean
	disabled?: boolean
	checked?: boolean
	className?: string
	value?: string | number
	name?: string
} & React.ComponentProps<'input'>

export function Checkbox({ indeterminate, ...props }: CheckboxProps) {
	const ref = useRef<HTMLInputElement>(null)
	useEffect(() => {
		if (ref.current) {
			ref.current.indeterminate = Boolean(indeterminate)
		}
	}, [ref, indeterminate, props.checked])

	return (
		<input
			data-slot='checkbox'
			{...props}
			role='checkbox'
			name={props.name}
			type='checkbox'
			className={cn(
				'size-4 shrink-0 grow-0 cursor-pointer rounded-[4px] border-border bg-input/20 text-primary outline-none focus:border-ring focus:ring-[3px] focus:ring-ring/30 focus:ring-offset-0 disabled:cursor-not-allowed disabled:text-disabled dark:bg-input/30',
				props.className
			)}
			ref={composeRefs(ref, props.ref)}
			aria-disabled={props.disabled}
			aria-checked={indeterminate ? 'mixed' : props.checked}
		/>
	)
}
